import { useEffect, useRef } from "react";

export function useIdleTimer({
  timeout,
  onAction,
  onIdle,
  onActive,
  debounce = 0,
}) {
  const idleTimeoutRef = useRef(null);
  const debounceRef = useRef(null);
  const isIdleRef = useRef(false);

  const events = [
    "mousemove",
    "mousedown",
    "keydown",
    "scroll",
    "touchstart",
  ];

  const resetIdleTimer = (event) => {
    // debounce onAction
    if (debounce) {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        onAction?.(event);
      }, debounce);
    } else {
      onAction?.(event);
    }

    // if user was idle → active
    if (isIdleRef.current) {
      isIdleRef.current = false;
      onActive?.();
    }

    clearTimeout(idleTimeoutRef.current);

    idleTimeoutRef.current = setTimeout(() => {
      isIdleRef.current = true;
      onIdle?.();
    }, timeout);
  };

  useEffect(() => {
    events.forEach((event) =>
      window.addEventListener(event, resetIdleTimer)
    );

    // start timer immediately
    idleTimeoutRef.current = setTimeout(() => {
      isIdleRef.current = true;
      onIdle?.();
    }, timeout);

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      clearTimeout(idleTimeoutRef.current);
      clearTimeout(debounceRef.current);
    };
  }, []);

  return {
    isIdle: () => isIdleRef.current,
  };
}
